import Cookies from 'cookies-js'

import { queueTrackingEvent } from '@library/tracking-integration'

import { get } from './cookieHelper2'

type ExperimentationUserImpression = {
  category: 'experimentation'
  action: 'experimentation_user_impression'
  properties: {
    experimentation_user_id: string
  }
}

export function trackExperimentationCookies(cookies: typeof Cookies) {
  const expUserIdCookie = get<{ exp_user_id: string }>(cookies, 'exp_user_id')

  if (expUserIdCookie?.exp_user_id) {
    const trackingData: ExperimentationUserImpression = {
      category: 'experimentation',
      action: 'experimentation_user_impression',
      properties: {
        experimentation_user_id: expUserIdCookie.exp_user_id,
      },
    }

    queueTrackingEvent<ExperimentationUserImpression>(trackingData)
  }
}
